module.exports = "https://web-assets.ifttt.com/packs/media/docs/trigger_field_string-6c09bd4d.gif";